import { RoomType } from "../types/C1_RoomTypes";

/** Name recognition takes precedence over legacy office/bedroom suggestions for child rooms. */
export function resolveImportedRoomType(name: string, suggestion?: string): RoomType | undefined {
  if (/^\s*(?:kind(?:erzimmer|er)?|child(?:ren)?(?:['’]s)?(?:\s+room)?)\b/i.test(name)) return RoomType.Child;
  return Object.values(RoomType).includes(suggestion as RoomType) ? suggestion as RoomType : undefined;
}
